import React from 'react'

import { Icon } from '@iconify/react'
import shareBoxLine from '@iconify/icons-ri/share-box-line';
import twitterFill from '@iconify/icons-ri/twitter-fill'

import useResponsive from '../hooks/useResponsive'

export default () => {

  const { untilWidescreen, isMobileMenu } = useResponsive()

  return (
    <ul className="sideNav__social social">
      <li className="social__item">
        <a target="_blank" rel="noreferrer" href="https://twitter.com/leocacom" className="social__link">
          <Icon icon={twitterFill} width={untilWidescreen ? 32 : 24} />
          {isMobileMenu && <>
            <div className="social__label">
              Twitter
            </div>
            <Icon className="social__newTab" icon={shareBoxLine} width={18} />
          </>}
          {!isMobileMenu && <div className="is-sr-only">Twitter</div>}
        </a>
      </li>
    </ul>
  )
}